const dailyWord = {


    '2022-01-22': {
        word: 'ANOIS',
        meaning: 'jdfksdjsl',
        number: 1
    },
    '2022-01-23': {
        word: 'SEALL',
        number: 2
    },
    '2022-01-24': {
        word: 'FEARR',
        number: 3
    },
    '2022-01-25': {
        word: 'DUINE',
        number: 1
    },
    '2022-01-26': {
        word: 'ABAIR',
        number: 2
    },
    '2022-01-27': {
        word: 'MAITH',
        number: 3
    },
    '2022-01-28': {
        word: 'FAIGH',
        number: 4
    },
    '2022-01-29': {
        word: 'TÉIGH',
        number: 5
    },
    '2022-01-30': {
        word: 'NUAIR',
        number: 6
    },
    '2022-01-31': {
        word: 'AMACH',
        number: 7
    },
    '2022-02-01': {
        word: 'CEANN',
        number: 8
    },
    '2022-02-02': {
        word: 'CAITH',
        number: 9
    },
    '2022-02-03': {
        word: 'CHOMH',
        number: 10
    },
    '2022-02-04': {
        word: 'CHUIG',
        number: 11
    },
    '2022-02-05': {
        word: 'OBAIR',
        number: 12
    },
    '2022-02-06': {
        word: 'TAOBH',
        number: 13
    },
    '2022-02-07': {
        word: 'ANOIS',
        number: 14
    },
    '2022-02-08': {
        word: 'CÉILE',
        number: 15
    },
    '2022-02-09': {
        word: 'TEACH',
        number: 16
    },
    '2022-02-10': {
        word: 'CEART',
        number: 17
    },
    '2022-02-11': {
        word: 'SCÉAL',
        number: 18
    },
    '2022-02-12': {
        word: 'ROIMH',
        number: 19
    },
    '2022-02-13': {
        word: 'CEIST',
        number: 20
    },
    '2022-02-14': {
        word: 'ANSIN',
        number: 21
    },
    '2022-02-15': {
        word: 'DÓIGH',
        number: 22
    },
    '2022-02-16': {
        word: 'POBAL',
        number: 23
    },
    '2022-02-17': {
        word: 'SCOIL',
        number: 24
    },
    '2022-02-18': {
        word: 'ROINN',
        number: 25
    },
    '2022-02-19': {
        word: 'ÚSÁID',
        number: 26
    },
    '2022-02-20': {
        word: 'LEITH',
        number: 27
    },
    '2022-02-21': {
        word: 'ANSEO',
        number: 28
    },
    '2022-02-22': {
        word: 'OÍCHE',
        number: 29
    },
    '2022-02-23': {
        word: 'BAILE',
        number: 30
    },
    '2022-02-24': {
        word: 'LUCHT',
        number: 31
    },
    '2022-02-25': {
        word: 'CÚRSA',
        number: 32
    },
    '2022-02-26': {
        word: 'EOLAS',
        number: 33
    },
    '2022-02-27': {
        word: 'IMIGH',
        number: 34
    },
    '2022-02-28': {
        word: 'CAINT',
        number: 35
    },
    '2022-03-01': {
        word: 'ÁBHAR',
        number: 36
    },
    '2022-03-02': {
        word: 'FÉACH',
        number: 37
    },
    '2022-03-03': {
        word: 'SIÚIL',
        number: 38
    },
    '2022-03-04': {
        word: 'ÉIGIN',
        number: 39
    },
    '2022-03-05': {
        word: 'BUAIL',
        number: 40
    },
    '2022-03-06': {
        word: 'RIAMH',
        number: 41
    },
    '2022-03-07': {
        word: 'FOCAL',
        number: 42
    },
    '2022-03-08': {
        word: 'BEIRT',
        number: 43
    },
    '2022-03-09': {
        word: 'MEASA',
        number: 44
    },
    '2022-03-10': {
        word: 'CLOIS',
        number: 45
    },
    '2022-03-11': {
        word: 'CÓNAÍ',
        number: 46
    },
    '2022-03-12': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 47
    },
    '2022-03-13': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 48
    },
    '2022-03-14': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 49
    },
    '2022-03-15': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 50
    },
    '2022-03-16': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-03-17': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-03-18': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-03-19': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-03-20': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-03-21': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-03-22': {
        word: 'SEALL',
        meaning: 'jdfksdjsl',
        number: 2
    },
    '2022-03-23': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-03-24': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-03-25': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-03-26': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-03-27': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-03-28': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-03-29': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-03-30': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-03-31': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-04-01': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-04-02': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-04-03': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-04-04': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-04-05': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-04-06': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-04-07': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-04-08': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-04-09': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-04-10': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-04-11': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-04-12': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-04-13': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-04-14': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-04-15': {
        word: 'CROIS',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-04-16': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-04-17': {
        word: 'SICÍN',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-04-18': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-04-19': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-04-20': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-04-21': {
        word: 'SEALL',
        meaning: 'jdfksdjsl',
        number: 2
    },
    '2022-04-22': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-04-23': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-04-24': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-04-25': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-04-26': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-04-27': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-04-28': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-04-29': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-04-30': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-05-01': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-05-02': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-05-03': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-05-04': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-05-05': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-05-06': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-05-07': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-05-08': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-05-09': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-05-10': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-05-11': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-05-12': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-05-13': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-05-14': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-05-15': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-05-16': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-05-17': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-05-18': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-05-19': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-05-20': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-05-21': {
        word: 'SEALL',
        meaning: 'jdfksdjsl',
        number: 2
    },
    '2022-05-22': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-05-23': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-05-24': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-05-25': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-05-26': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-05-27': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-05-28': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-05-29': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
    '2022-05-30': {
        word: 'FEARR',
        meaning: 'jdfksdjsl',
        number: 3
    },
}

export default dailyWord;
